// extracted by mini-css-extract-plugin
export default {"sidebar":"DesktopListingDetailsSidebar_sidebar__4V9hJ","section":"DesktopListingDetailsSidebar_section__R0dnA"};